"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constants = void 0;

var _types = require("./types");

var constants = [{
  regionCode: _types.Region.SG,
  regionFullName: "Singapore",
  languageCodes: ["en", "zh"],
  currencyCode: ["SGD"],
  phoneHead: "+65",
  priceSymbol: "$",
  regPhonePattern: /^\s*[8,9]{1}\d{7}$/,
  maxPhoneLength: 8,
  webOnlineDomain: "https://ezbuy.sg",
  mwebOnlineDomain: "https://m.ezbuy.sg",
  isPrimeEnable: true,
  isFlashDealEnabled: true,
  isMillionEnabled: true,
  primeShippingFee: 2.99
}, {
  regionCode: _types.Region.MY,
  regionFullName: "Malaysia",
  languageCodes: ["en", "ms", "zh"],
  currencyCode: ["MYR"],
  phoneHead: "+60",
  priceSymbol: "RM",
  regPhonePattern: /^([1-9])(\d{8,10})$/,
  maxPhoneLength: 11,
  webOnlineDomain: "https://ezbuy.my",
  mwebOnlineDomain: "https://m.ezbuy.my",
  isPrimeEnable: false,
  isFlashDealEnabled: true,
  primeShippingFee: 8.8
}, {
  regionCode: _types.Region.TH,
  regionFullName: "Thailand",
  languageCodes: ["en", "th"],
  currencyCode: ["THB"],
  phoneHead: "+66",
  priceSymbol: "฿",
  regPhonePattern: /^0?[1-9]\d{8}$/,
  maxPhoneLength: 10,
  webOnlineDomain: "https://ezbuy.co.th",
  mwebOnlineDomain: "https://m.ezbuy.co.th",
  isFlashDealEnabled: true
}, {
  regionCode: _types.Region.TWC,
  regionFullName: "Taiwan",
  languageCodes: ["zhtw", "en"],
  currencyCode: ["TWD"],
  phoneHead: "+886",
  priceSymbol: "NT$",
  regPhonePattern: /^(0\d{9}|[1-9]\d{8})$/,
  maxPhoneLength: 10,
  webOnlineDomain: "https://tw.ezbuy.com",
  mwebOnlineDomain: "https://m-tw.ezbuy.com",
  isFlashDealEnabled: true
}, {
  regionCode: _types.Region.PK,
  regionFullName: "Pakistan",
  languageCodes: ["en"],
  currencyCode: ["PKR"],
  phoneHead: "+92",
  priceSymbol: "PKR",
  regPhonePattern: /^\d{10,11}$/,
  maxPhoneLength: 11,
  webOnlineDomain: "https://pk.ezbuy.com",
  mwebOnlineDomain: "https://m-pk.ezbuy.com",
  isFlashDealEnabled: true
}, {
  regionCode: _types.Region.AUE,
  languageCodes: ["en", "zhtw"],
  currencyCode: ["AUD"],
  phoneHead: "+61",
  priceSymbol: "AU $",
  regPhonePattern: /^\d{9,10}$/,
  maxPhoneLength: 10
}, {
  regionCode: _types.Region.HK,
  languageCodes: ["en", "zhtw"],
  currencyCode: ["HKD"],
  phoneHead: "+852",
  priceSymbol: "HK $",
  regPhonePattern: /^\d{8}$/,
  maxPhoneLength: 8
}];
exports.constants = constants;